"use client";

import type { UseFormReturn } from "react-hook-form";

import { ConfigFormRenderer } from "@/components/Form/ConfigFormRenderer";
import { CopyableUrlField } from "@/components/Form/CopyableUrlField";
import type { NoxusFormEntryConfig } from "@/components/Spotflow/ConfigDrawer/ConfigDrawer";

import type { ProviderInfo } from "./types";

/** The OAuth app a provider takes on the connection form, plus the redirect
 *  URL the user registers on that app. */
export function OAuthAppForm({
  provider,
  integrationName,
  config,
  form,
  keepsSecret,
}: {
  provider: ProviderInfo;
  integrationName: string;
  config: Record<string, NoxusFormEntryConfig>;
  form: UseFormReturn<Record<string, unknown>>;
  keepsSecret?: boolean;
}) {
  return (
    <div className="flex flex-col gap-4">
      {provider.oauth_redirect_uri && (
        <CopyableUrlField
          label="Redirect URL"
          url={provider.oauth_redirect_uri}
          description={`Set this as the redirect URL of the OAuth app on your ${integrationName} instance.`}
        />
      )}
      <ConfigFormRenderer
        config={config}
        form={form}
        getNodeById={() => undefined}
      />
      {keepsSecret && (
        <p className="text-xs text-muted-foreground">
          Leave the client secret blank to keep the current one, as long as the
          other fields stay the same.
        </p>
      )}
    </div>
  );
}
